module.exports = require('./AdvertisingBanner');